import { InputAdornment } from '@mui/material'
import HikingIcon from '@mui/icons-material/Hiking'
import GpsFixedIcon from '@mui/icons-material/GpsFixed'
import SwapHorizontalCircleIcon from '@mui/icons-material/SwapHorizontalCircle'
import HeightIcon from '@mui/icons-material/Height'
import RotateLeftIcon from '@mui/icons-material/RotateLeft'
import VerticalAlignTopIcon from '@mui/icons-material/VerticalAlignTop'
import NatureIcon from '@mui/icons-material/Nature'
import NaturePeopleIcon from '@mui/icons-material/NaturePeople'
import TimelineIcon from '@mui/icons-material/Timeline'
import LocalFloristIcon from '@mui/icons-material/LocalFlorist'
import GrainIcon from '@mui/icons-material/Grain'
import TurnSlightRightIcon from '@mui/icons-material/TurnSlightRight'
import SwapHorizIcon from '@mui/icons-material/SwapHoriz'
import { getMetaFeaturesAll } from '../../services'
import _ from 'lodash'

const getIcons = key => {
  const iconsList = {
    altitud: HikingIcon,
    longX: GpsFixedIcon,
    latY: GpsFixedIcon,
    cap: SwapHorizontalCircleIcon,
    ht: HeightIcon,
    dap: RotateLeftIcon,
    hc: VerticalAlignTopIcon,
    copaNS: NaturePeopleIcon,
    copaEW: NaturePeopleIcon,
    follaje: NatureIcon,
    madurez: TimelineIcon,
    floracion: LocalFloristIcon,
    fructificacion: GrainIcon,
    fusteRectitud: TurnSlightRightIcon,
    espaciamiento: SwapHorizIcon,
  }
  return iconsList[key]
}

function getOptions(dataInText) {
  let options = {}
  const listOptions = dataInText.split(',')
  listOptions.forEach(value => {
    const v = _.trim(value)
    let ObjNew = {}
    ObjNew[v] = v
    options = { ...options, ...ObjNew }
  })
  return options
}

function isAOptionType(key) {
  const isOptionsType = [
    'madurez',
    'floracion',
    'fructificacion',
    'fusteRectitud',
    'espaciamiento',
  ]
  return isOptionsType.some(isSome => isSome === key)
}

export const attributesItems = async () => {
  const TYPE_COORDINATES = ['longX', 'latY']
  const response = await getMetaFeaturesAll()
  const { res: metaFeatures } = response
  if (!metaFeatures) return console.log('Falló conexión getMetaFeaturesAll ::', response)

  const items = metaFeatures.map(obj => {
    const { key: name, nombre: label, tipo_dato, u_medida } = obj
    const IconName = getIcons(name)

    let objToReturn = {
      x: 12,
      s: 6,
      m: 4,
      initvalue: '',
      name,
      label,
      type: tipo_dato === 'entero' ? 'number' : undefined,
      icon_: {
        startAdornment: (
          <InputAdornment position="start">
            {IconName && <IconName sx={{ fontSize: 16 }} />}
          </InputAdornment>
        ),
      },
      placeholder: _.includes(TYPE_COORDINATES, name) ? `Crear PIN en mapa` : u_medida,
      options: isAOptionType(name) ? getOptions(u_medida) : undefined,
    }
    return objToReturn
  })
  return items
}
